import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import "./NewProductForm.scss";
import { db, storage } from "../../../firebase";
import { getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";
import { addDoc, collection, getDocs } from "firebase/firestore";
import ImageOrderManager from "../../ImageOrderManager/ImageOrderManager";

function NewProductForm() {
  const [isSubmit, setIsSubmit] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progress1, setProgress1] = useState(0);
  const [files, setFiles] = useState(null);
  const [mainFile, setMainFile] = useState(null);
  const [imageUrls, setImageUrls] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [displayAsSold, setDisplayAsSold] = useState(false);

  // upload to firebase

  const uploadMainImage = (file) => {
    // if file doesnt exist return
    if (!file) return;
    // if file does exist;

    const storageRef = ref(
      storage,
      `/product-images/${file.lastModified}${file.name}`
    );
    let uploadTask = uploadBytesResumable(storageRef, file);
    return uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress1(prog);
      },
      (err) => console.log(err),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          setMainImage(url);
        });
      }
    );
  };

  const uploadFile = (file) => {
    // if file doesnt exist return
    if (!file) return;
    // if file does exist;

    const storageRef = ref(
      storage,
      `/product-images/${file.lastModified}${file.name}`
    );
    let uploadTask = uploadBytesResumable(storageRef, file);
    return uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(prog);
      },
      (err) => console.log(err),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          setImageUrls((prevState) => [...prevState, url]);
        });
      }
    );
  };

  const handleChange = (e) => {
    setFiles(e.target.files);
  };

  const handleMainImageChange = (e) => {
    setMainFile(e.target.files);
    // console.log(e.target.files);
  };

  const handleUpload = () => {
    for (let i = 0; i < files.length; i++) {
      uploadFile(files[i]);
    }
  };

  const handleMainUpload = () => {
    uploadMainImage(mainFile[0]);
  };

  const handleReorderImages = (reordered) => {
    setImageUrls(reordered);
  };

  const handleRemoveImage = (index) => {
    setImageUrls((prev) => prev.filter((_, i) => i !== index));
  };

  const handlePromoteToMain = (url) => {
    setMainImage(url);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (imageUrls) {
      const newProduct = {
        // Add key value pairs for new warehouse
        title: e.target.title.value,
        sku: e.target.sku.value,
        description: e.target.description.value,
        rrp: e.target.rrp.value,
        price: e.target.price.value,
        salePrice: e.target.salePrice.value,
        condition: e.target.condition.value,
        metal: e.target.metal.value,
        gem: e.target.gem.value || "",
        brand: e.target.brand.value,
        jewellery: e.target.jewellery.value,
        size: e.target.size.value ? e.target.size.value : "",
        brandRef: e.target.brandRef.value,
        mainImage: mainImage,
        images: imageUrls,
        featured: e.target.featured.value,
        available: e.target.available.value,
        displayAsSold: displayAsSold,
      };
      const productsCollectionRef = collection(db, "products");
      const createNewProduct = async () => {
        await addDoc(productsCollectionRef, newProduct);
        setIsSubmit(true);
      };
      createNewProduct();
    }

    e.target.reset();

    setImageUrls([]);
  };

  // handle model actions;

  const addNew = () => {
    setIsSubmit(false);
  };

  const returnToInventory = () => {
    setIsSubmit(false);
  };

  // Dropdown Styling

  const borderStyle = {
    control: (styles) => ({
      ...styles,
      borderRadius: "8px",
      minHeight: "48px",
      fontSize: "1.15rem",
    }),
  };

  //Dropdown Options

  const conditionOptions = [
    { value: "Brand New", label: "Brand New" },
    { value: "Ex-Display", label: "Ex-Display" },
    { value: "Unworn", label: "Unworn" },
    { value: "Excellent", label: "Excellent" },
    { value: "Good", label: "Good" },
    { value: "Gently Used", label: "Gently Used" },
  ];

  const featuredOptions = [
    { value: "true", label: "Featured" },
    { value: "false", label: "Not Featured" },
  ];
  const availableOptions = [
    { value: "Is Available", label: "Is Available" },
    { value: "Not Available", label: "Not Available" },
    { value: "Sold", label: "Sold" },
    { value: "Enquire", label: "Enquire" },
  ];

  const [brands, setBrands] = useState(null);
  const [jewelleryList, setJewelleryList] = useState(null);

  const getBrands = async () => {
    const brandsCollectionRef = collection(db, "brands");
    const data = await getDocs(brandsCollectionRef);
    let results = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    setBrands(results);
  };

  const getJewellery = async () => {
    const jewelleryCollectionRef = collection(db, "jewellery");
    const data = await getDocs(jewelleryCollectionRef);
    let results = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    setJewelleryList(results);
  };

  useEffect(() => {
    getBrands();
    getJewellery();
  }, []);

  if (!brands || !jewelleryList) {
    return <h1>Loading...</h1>;
  }

  const brandOptions = [];
  const getBrandOptions = () => {
    brands.forEach((brand) => {
      brandOptions.push({ value: brand.brandName, label: brand.brandName });
    });
  };
  getBrandOptions();

  const jewelleryOptions = [];
  const getJewelleryOptions = () => {
    jewelleryList.forEach((item) => {
      jewelleryOptions.push({
        value: item.jewelleryCategory,
        label: item.jewelleryCategory,
      });
    });
  };
  getJewelleryOptions();

  return (
    <div className="new-product">
      {isSubmit && (
        <div className="modal">
          <div className="modal__container">
            <h3>New Product Added</h3>
            <button type="button" onClick={addNew}>
              Add Another Product
            </button>
            <Link to="/bj-admin/inventory">
              <button type="button" onClick={returnToInventory}>
                Return To Inventory
              </button>
            </Link>
          </div>
        </div>
      )}
      <h1 className="new-product__title">Add New Product</h1>
      <Link to="/bj-admin/inventory">
        <button type="button" className="new-product__back-btn">
          Return To Inventory
        </button>
      </Link>
      <form className="new-product__form" onSubmit={handleSubmit}>
        <div className="new-product__section">
          <h3 className="new-product__section-title">Basic Information</h3>
          <div className="new-product__field">
            <label htmlFor="title">Title</label>
            <input type="text" name="title" required />
          </div>
          <div className="new-product__field">
            <label htmlFor="description">Description</label>
            <textarea name="description" required />
          </div>
          <div className="new-product__row">
            <div className="new-product__field">
              <label htmlFor="sku">SKU</label>
              <input type="text" name="sku" required />
            </div>
            <div className="new-product__field">
              <label htmlFor="brandRef">Brand Reference</label>
              <input type="text" name="brandRef" id="brandRef" />
            </div>
          </div>
        </div>

        <div className="new-product__section">
          <h3 className="new-product__section-title">Pricing</h3>
          <div className="new-product__row">
            <div className="new-product__field">
              <label htmlFor="price">Price</label>
              <input type="text" name="price" required />
            </div>
            <div className="new-product__field">
              <label htmlFor="rrp">RRP Price</label>
              <input type="text" name="rrp" />
            </div>
            <div className="new-product__field">
              <label htmlFor="salePrice">Sale Price</label>
              <input type="text" name="salePrice" />
            </div>
          </div>
        </div>

        <div className="new-product__section">
          <h3 className="new-product__section-title">Details</h3>
          <div className="new-product__row">
            <div className="new-product__field">
              <label htmlFor="condition">Condition</label>
              <Select
                options={conditionOptions}
                name="condition"
                styles={borderStyle}
                required
              />
            </div>
            <div className="new-product__field">
              <label htmlFor="brand">Brand</label>
              <Select
                options={brandOptions}
                name="brand"
                styles={borderStyle}
                required
              />
            </div>
          </div>
          <div className="new-product__row">
            <div className="new-product__field">
              <label htmlFor="jewellery">Jewellery Type</label>
              <Select
                options={jewelleryOptions}
                name="jewellery"
                styles={borderStyle}
                required
              />
            </div>
            <div className="new-product__field">
              <label htmlFor="metal">Metal</label>
              <input type="text" name="metal" />
            </div>
          </div>
          <div className="new-product__row">
            <div className="new-product__field">
              <label htmlFor="gem">Gemstone</label>
              <input type="text" name="gem" />
            </div>
            <div className="new-product__field">
              <label htmlFor="size">Size</label>
              <input type="text" name="size" defaultValue="" />
            </div>
          </div>
          <div className="new-product__row">
            <div className="new-product__field">
              <label htmlFor="cert">Certification</label>
              <input type="text" name="cert" />
            </div>
            <div className="new-product__field">
              <label htmlFor="packaging">Packaging</label>
              <input type="text" name="packaging" />
            </div>
          </div>
        </div>

        <div className="new-product__section">
          <h3 className="new-product__section-title">Main Image</h3>
          <div className="new-product__upload-area">
            <progress
              className="new-product__progress"
              value={progress1}
              max="100"
            />
            <div className="new-product__upload-controls">
              <input
                type="file"
                name="mainImage"
                required
                onChange={handleMainImageChange}
                accept="image/*"
              />
              <button
                className="new-product__upload-btn"
                onClick={handleMainUpload}
                type="button"
              >
                Upload
              </button>
            </div>
            {mainImage && (
              <div className="new-product__main-preview">
                <img src={mainImage} alt="Main preview" />
              </div>
            )}
          </div>
        </div>

        <div className="new-product__section">
          <h3 className="new-product__section-title">Gallery Images</h3>
          <div className="new-product__upload-area">
            <progress
              className="new-product__progress"
              value={progress}
              max="100"
            />
            <div className="new-product__upload-controls">
              <input
                type="file"
                name="images"
                required
                multiple
                onChange={handleChange}
                accept="image/*"
              />
              <button
                className="new-product__upload-btn"
                onClick={handleUpload}
                type="button"
              >
                Upload
              </button>
            </div>
          </div>
          <ImageOrderManager
            images={imageUrls}
            onReorder={handleReorderImages}
            mainImage={mainImage}
            onSetMainImage={handlePromoteToMain}
            onRemoveImage={handleRemoveImage}
          />
        </div>

        <div className="new-product__section">
          <h3 className="new-product__section-title">Visibility</h3>
          <div className="new-product__row">
            <div className="new-product__field">
              <label htmlFor="featured">Featured</label>
              <Select
                options={featuredOptions}
                name="featured"
                styles={borderStyle}
                required
              />
            </div>
            <div className="new-product__field">
              <label htmlFor="available">Availability</label>
              <Select
                options={availableOptions}
                name="available"
                styles={borderStyle}
                required
              />
            </div>
          </div>
          <div className="new-product__toggle">
            <label
              htmlFor="displayAsSold"
              className="new-product__toggle-label"
            >
              <input
                type="checkbox"
                name="displayAsSold"
                id="displayAsSold"
                checked={displayAsSold}
                onChange={(e) => setDisplayAsSold(e.target.checked)}
              />
              Display as Sold on website
            </label>
          </div>
        </div>

        <button className="new-product__submit">Add New Product</button>
      </form>
    </div>
  );
}

export default NewProductForm;
